<template>
  <div class="mobileHotelMenu" @click="$emit('close')">
    <scrollactive
        :offset="180"
        :modifyUrl="false"
        :highlightFirstItem="true"
        class="flex items-center">
        <div class="mobileHotelMenu__list">
          <li class="list-reset py-16 text-grey-darker hover:text-blue" @click="onOpenLangModal">
            <div class="text-center">{{ $t('language') }}: {{ selectedLangName }}</div>
          </li>
          <li class="list-reset py-16 text-grey-darker hover:text-blue" @click="onOpenCurrencyModal">
            <div class="text-center">{{ $t('currency') }}: {{ selectedCurrencyName }}</div>
          </li>
          <template v-if="$route.name === 'HotelDetail'">
            <hr class="border-b border-grey-lightest my-8 p-0">
            <a href="#anchor__hotel-info" class="mobileHotelMenu__item scrollactive-item">{{ $t('hotelDetail.title.hotelInfo') }}</a>
            <a href="#anchor__hotel-rooms" class="mobileHotelMenu__item scrollactive-item">{{ $t('hotelDetail.title.roomType') }}</a>
            <a href="#anchor__hotel-features" class="mobileHotelMenu__item scrollactive-item">{{ $t('hotelDetail.title.features') }}</a>
            <a href="#anchor__hotel-terms" class="mobileHotelMenu__item scrollactive-item">{{ $t('hotelDetail.title.bookingTerms') }}</a>
            <a href="#anchor__hotel-map" class="mobileHotelMenu__item scrollactive-item">{{ $t('hotelDetail.title.position') }}</a>
          </template>
        </div>
      </scrollactive>
      <modal class="mobileMenu langModal" name="langModal" :adaptive="true" width="80%" height="80%">
        <li v-for="lang in this['user/langsList']" :key="lang.code" :class="isSelectedLang(lang.code)" @click="switchLang(lang.code)">{{lang.name}}</li>
      </modal>
      <modal class="mobileMenu currencyModal" name="currencyModal" :adaptive="true" width="80%" height="80%">
        <div @click="$modal.hide('currencyModal')">
          <li v-for="(currency, index) in this['user/currenciesList']" :class="isSelectedCurrency(currency.code)" @click="switchCurrency(currency.code)" :key="index">
            <span>{{ currency.name }}</span>
            <span class="ml-4">{{ currency.icon }}</span>
          </li>
        </div>
      </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'mobileHotelMenu',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      'user/langsList': 'user/langsList',
      'user/currenciesList': 'user/currenciesList',
      selectedLangName: 'user/selectedLangName',
      selectedCurrencyName: 'user/selectedCurrencyName'
    })
  },
  methods: {
    ...mapActions({
      'user/switchLang': 'user/switchLang',
      'user/switchCurrency': 'user/switchCurrency'
    }),
    isSelectedLang: function (lang) {
      return lang === this['user/selectedLang'] ? 'activate' : null
    },
    isSelectedCurrency: function (currency) {
      return currency === this['user/selectedCurrency'] ? 'activate' : null
    },
    onOpenLangModal: function () {
      this.$modal.show('langModal')
    },
    onOpenCurrencyModal: function () {
      this.$modal.show('currencyModal')
    },
    switchLang: function (lang) {
      this['user/switchLang'](lang)
    },
    switchCurrency: function (currency) {
      this['user/switchCurrency'](currency)
    }
  }
}
</script>

<style lang="sass">
.mobileHotelMenu
  &__list
    @apply w-full
  &__item
    @apply text-grey-darker no-underline block px-8 py-16 text-center
    &.is-active
      @apply text-blue
</style>
